import { CheckoutField } from '@mews-distributor/common';

export const baseRequiredFields = [
    CheckoutField.LastName,
    CheckoutField.BookerLastName,
    CheckoutField.BookerEmail,
    CheckoutField.CardNumber,
    CheckoutField.CardExpiration,
    CheckoutField.CardCVV,
    CheckoutField.CardHolderName,
    CheckoutField.AgreeWithConditions,
];

export const configurableRequiredFields = {
    [CheckoutField.Telephone]: [CheckoutField.Telephone, CheckoutField.BookerTelephone],
};
